export const MEMBERSHIP_COURSE_API = '/api/membership/course'
